/**
 * 파일명: tomorrowStartsHere.js
 * 작성자: 김준형
 * 작성일자: 26.08.10
 * 설명: About Us - Tomorrow Starts Here
 */
import React from "react";
import useAboutBg from "components/about/aboutAsset";
import useDesignLines from "components/about/aboutLines";
import style from "css/about.module.css";

const VALUE_CARDS = [
  {
    key: "tech",
    title: "독보적 기술 경쟁력 확보",
    lines: [
      '리브테크놀로지는 기술 기업의 생명은 결국 "남다른 가치"에 ',
      "있다고 믿고 있습니다. 기존의 하이브리드 워킹 기술을 뛰어",
      "넘어 인공지능과 데이터 중심의 혁신을 가속화하여 고객이 ",
      "상상만 하던 미래를 현실로 구현하는 독보적인 기술력을 ",
      "갖춤으로써 새로운 스마트 오피스 시장의 표준으로 거듭",
      "나겠습니다.",
    ],
  },
  {
    key: "customer",
    title: "고객 중심의 가치 창출",
    lines: [
      "기술은 고객의 문제를 해결해낼 때 비로소 완성됩니다. ",
      "리브테크놀로지는 공급자 중심의 사고에서 벗어나 ",
      "철저한 사후 분석과 고객 목소리에 귀 기울이고, ",
      "고객의 불편함을 혁신적인 서비스로 해소함으로써 ",
      '"고객 지향적 혁신"을 이루어 나가겠습니다.',
    ],
  },
  {
    key: "culture",
    title: "유연하고 건강한 조직 문화",
    lines: [
      "혁신은 원활한 소통과 구성원들의 열정과 의지에서 비롯되며, ",
      "창의적인 아이디어는 상호 존중에 기반한 건강한 조직 문화",
      "에서 피어납니다. ",
      "실패를 두려워하지 않고 도전하는 문화, 서로의 성장을 ",
      "진심으로 응원하는 리브테크놀로지만의 단단한 팀워크를 ",
      "다져 나가겠습니다.",
    ],
  },
];

function TomorrowStartsHere() {
  const bg = useAboutBg();
  const lines = useDesignLines();

  return (
    <section
      className={style.ab_tsh}
      style={bg("tomorrow")}
    >
      <h2 className={style.ab_tsh_title}>
        Tomorrow{" "}
        <br className={style.ab_tsh_title_br} />
        Starts Here
      </h2>
      <span className={style.ab_tsh_line} />

      <div className={style.ab_tsh_card_list}>
        {VALUE_CARDS.map((card) => (
          <div
            className={`${style.ab_tsh_card} ${style[`ab_tsh_card_${card.key}`]}`}
            style={bg(`value_${card.key}`)}
            key={card.key}
          >
            <div className={style.ab_tsh_card_title}>{card.title}</div>
            <p className={style.ab_tsh_card_desc}>{lines(card.lines)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TomorrowStartsHere;
